//Motif
import Motif from "@/pages/administrer/configuration/motifs/Motif.vue";
import CreateMotif from "@/pages/administrer/configuration/motifs/CreateMotif.vue";
import ShowMotif from "@/pages/administrer/configuration/motifs/ShowMotif.vue";

export default [
    {
        path: 'motifs',
        meta: { permissions: ["view_no_follow_up_reason"] },
        name: "AdminConfigMotif",
        component: Motif
    },
    {
        path: 'motifs/create',
        meta: { permissions: ["create_no_follow_up_reason"] },
        name: "AdminConfigCreateMotif",
        component: CreateMotif
    },
    {
        path: 'motifs/:id/show',
        meta: { permissions: ["view_any_no_follow_up_reason"] },
        name: "AdminConfigShowMotif",
        component: ShowMotif
    },
]
